import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonToolbar, IonTitle, IonLabel, IonButton } from '@ionic/angular/standalone';
import { NotificationService } from '../../../services/notification.service';
import { TranslocoModule, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';


export interface PushNotificationModalInput {
  modalTitle: string;
  modalMessage?: string;

  notificationId?: string;
  notificationType: string;
  timestamp?: string;

  bodyRaw?: string;
  bodyParsed?: any;

  route?: string | null;

  detailsLines: Array<{ label: string; value?: string }>;

  raw: any;

  /**
   * `true` rende questa modale immune alla chiusura automatica durante una navigazione dichiarata
   * `autoSkip` (gli auto-skip delle schermate a un solo elemento). Vedi
   * `AutocloseOverlaysService.trigger`. Diverso da `isNotDismissableWithBack`: il tasto indietro
   * deve continuare a chiudere questa modale normalmente.
   */
  isAutoSkipSafe?: boolean;
}

@Component({
    selector: 'app-push-notification-modal',
    templateUrl: './push-notification-modal.component.html',
    styleUrls: ['./push-notification-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonButton, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class PushNotificationModalComponent {

  @Input() modalTitle!: string;
  @Input() modalMessage?: string;

  @Input() notificationId?: string;
  @Input() notificationType!: string;
  @Input() timestamp?: string;

  @Input() bodyRaw?: string;
  @Input() bodyParsed?: any;

  @Input() route?: string | null;

  @Input() detailsLines: Array<{ label: string; value?: string }> = [];
  @Input() raw: any;

  showRaw = false;

  constructor(
    private modalCtrl: ModalController,
    private notificationService: NotificationService,
    private transloco: TranslocoService,
  ) {}

  toggleRaw(): void {
    this.showRaw = !this.showRaw;
  }

  async close(): Promise<void> {
    await this.modalCtrl.dismiss();
  }

  async open(): Promise<void> {
    if (!this.route) return;
    await this.modalCtrl.dismiss({ action: 'open', route: this.route });
  }

  get hasDetails(): boolean {
    return !!(this.bodyRaw || this.bodyParsed || this.raw);
  }

  get formattedBody(): string | null {
    if (this.bodyParsed != null) {
      try {
        return JSON.stringify(this.bodyParsed, null, 2);
      } catch {
        return String(this.bodyParsed);
      }
    }
    if (this.bodyRaw) return this.bodyRaw;
    return null;
  }

  get formattedRaw(): string {
    try {
      return JSON.stringify(this.raw ?? {}, null, 2);
    } catch {
      return String(this.raw ?? '');
    }
  }

  async copy(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      this.notificationService.openToast({ message: this.transloco.translate('shared.push_notification.copiato'), color: 'success' });
    } catch {
      // La copia non è più un fallimento silenzioso: feedback minimale. Vedi spec ui-feedback.
      this.notificationService.openToast({ message: this.transloco.translate('shared.push_notification.copiaErrore'), color: 'danger' });
    }
  }
}
